import { render, staticRenderFns } from "./PIPLife.vue?vue&type=template&id=67ebdad6&scoped=true&"
import script from "./PIPLife.vue?vue&type=script&lang=js&"
export * from "./PIPLife.vue?vue&type=script&lang=js&"
import style0 from "./PIPLife.vue?vue&type=style&index=0&id=67ebdad6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ebdad6",
  null
  
)

export default component.exports